import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';

import { Row, Col } from 'react-bootstrap';
import columns from './Coaches/columns';

import { useTeamCoachPoolContext } from '../../../contexts/TeamCoachPoolContext';

export default function Coaches() {
  const { dispatch, actions, state } = useTeamCoachPoolContext();

  useEffect(() => {
    actions.loadCoaches(dispatch, state.team);
  }, []);

  return (
    <>
      <Row>
        <Col md={12}>
          <h2 className="block-title">
            {state.team.attributes.coach_pool_name}
          </h2>
        </Col>
      </Row>
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={state.coaches || []}
          noDataComponent={(
            <div className="mt20">
              {state.coaches == null
                ? 'Please, wait ...'
                : 'No matching records found'}
            </div>
          )}
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
        />
      </div>
    </>
  );
}
